// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 955) return "static/chunks/955-b10d3f7ade3f46e7.js";
	if (chunkId === 624) return "static/chunks/624-a3a593407679cc83.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"790f4fbafe4200f7","205":"2e90144ef4045da8","319":"0cbc2894a3f1b950","340":"abfe699b8691adc7","367":"4ae4e590d8733824","639":"5cc156d45fbc1844","748":"47d568323ba30a5c"}[chunkId] + ".js";
};